// slices/notificationSlice.js

import { Notification, NotificationType } from '../../types/NotificationTypes';
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import apiClient from '../../services/apiClient';

interface NotificationsState {
  notifications: Notification[];
}

const initialState: NotificationsState = {
  notifications: [],
};

const Api = process.env.REACT_APP_AUTH_API_URL;
// console.log("Api",Api)

// Async thunk for fetching all notifications
export const fetchAllNotifications = createAsyncThunk(
  'notifications/fetchAll',
  async () => {
    const response = await apiClient.get<Notification[]>(Api+'/notifications/all');
    // console.log("notifications", response.data)
    return response.data;
  }
);

// Async thunk for marking a notification as read
export const markNotificationAsRead = createAsyncThunk(
  'notifications/markAsRead',
  async ({ id, notificationType }: { id: number; notificationType: NotificationType }, { dispatch }) => {
    console.log("from markNotificationAsRead", id +" "+ notificationType)
    await apiClient.post(`${Api}/notifications/${notificationType}/${id}/read`);
    // After marking as read in the backend, update the state in the frontend
    dispatch(updateNotificationReadStatus(id));
  }
);;

const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    receiveNotification: (state, action: PayloadAction<Notification>) => {
      state.notifications.unshift(action.payload);
    },
    // Reducer to update the read status in the state
    updateNotificationReadStatus: (state, action: PayloadAction<number>) => {
      const index = state.notifications.findIndex(n => n.id === action.payload);
      if (index !== -1) {
        state.notifications[index].read = true;
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllNotifications.fulfilled, (state, action: PayloadAction<Notification[]>) => {
      state.notifications = action.payload;
    });
  },
});

export const { receiveNotification, updateNotificationReadStatus } = notificationSlice.actions;

export default notificationSlice.reducer;